import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/Contemporary_Period_-_Digital_Revolution.png';

function HistoryPageDigitalRevolutionGo() {
  return (
    <QuizPage
      title="History: Digital Revolution"
      subTopic="Digital Revolution"
      backgroundImage={historyImage}
      returnPath="/History-Digital-Revolution"
    />
  );
}

export default HistoryPageDigitalRevolutionGo;
